"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClipboardIcon = function ClipboardIcon() {
  return _react2.default.createElement(
    "svg",
    {
      className: "quiver-clipboard-icon",
      xmlns: "http://www.w3.org/2000/svg", width: "19", height: "19", viewBox: "0 0 19 19"
    },
    _react2.default.createElement(
      "g",
      { fillRule: "evenodd" },
      _react2.default.createElement(
        "g",
        { transform: "translate(-498.000000, -320.000000)", fillRule: "nonzero" },
        _react2.default.createElement(
          "g",
          { transform: "translate(398.000000, 310.000000)" },
          _react2.default.createElement(
            "g",
            { transform: "translate(90.000000, 0.000000)" },
            _react2.default.createElement(
              "g",
              { transform: "translate(10.000000, 10.000000)" },
              _react2.default.createElement("path", {
                d: "M8.49286,12.64596 L8.38746,12.61774 L6.72418,14.28136 C6.18902,14.81652 5.4774,\n                  15.11096 4.72056,15.11096 C3.96372,15.11096 3.2521,14.81652 2.71694,14.28136\n                  C1.61228,13.17636 1.61228,11.37878 2.71694,10.27412 L4.98372,8.00734 C5.51888,\n                  7.47218 6.2305,7.17774 6.98734,7.17774 C7.51094,7.17774 8.02196,7.32122 8.46566,\n                  7.59322 C8.65538,7.7095 8.83184,7.8489 8.99062,8.00734 C9.1494,8.16612 9.2888,\n                  8.34258 9.40508,8.5323 L9.44214,8.59316 L9.51048,8.61424 C9.6713,8.66354 9.83926,\n                  8.68836 10.00926,8.68836 C10.46418,8.68836 10.89156,8.51122 11.21252,8.18958\n                  L11.3067,8.09506 L11.24924,7.9747 C11.01804,7.49122 10.70728,7.05262 10.32614,\n                  6.67148 C9.945,6.29 9.5064,5.97958 9.02292,5.74838 C8.3929,5.44748 7.6891,\n                  5.28836 6.987,5.28836 C5.82794,5.28836 4.71376,5.71166 3.84982,6.4804 C3.78114,\n                  6.5416 3.71382,6.60552 3.64786,6.67148 L1.38108,8.93826 C-0.46002,10.77936\n                  -0.46002,13.7751 1.38108,15.61654 C2.27392,16.5087 3.45984,17 4.72124,17 C5.9823,\n                  17 7.16822,16.5087 8.06038,15.61688 L10.32716,13.35044 C10.39312,13.28414\n                  10.45704,13.21614 10.51824,13.1478 L10.82186,12.80576 L10.36558,12.83364\n                  C9.74066,12.8707 9.09942,12.80814 8.49286,12.64596 Z"
              }),
              _react2.default.createElement("path", {
                d: "M15.61552,1.38278 C14.7237,0.49096 13.53778,0 12.27638,0 C11.01498,0 9.8294,\n                  0.49096 8.93724,1.38278 L6.6708,3.64956 C6.60484,3.71552 6.54126,3.78318 6.47972,\n                  3.8522 L6.1761,4.1939 L6.63238,4.16602 C7.25696,4.12828 7.8982,4.19152 8.50442,\n                  4.3537 L8.60982,4.38192 L10.27276,2.71864 C10.80826,2.18348 11.51988,1.8887\n                  12.27672,1.8887 C13.0339,1.8887 13.74518,2.18348 14.28034,2.71864 C15.385,3.8233\n                  15.385,5.62088 14.28034,6.72554 L12.0139,8.99232 C11.47874,9.52714 10.76712,\n                  9.82192 10.01028,9.82192 C9.48668,9.82192 8.97532,9.6781 8.53162,9.4061 C8.34258,\n                  9.29016 8.16578,9.15076 8.00666,8.99232 C7.84788,8.83286 7.70848,8.6564 7.59254,\n                  8.46702 L7.55514,8.40582 L7.4868,8.38474 C7.32564,8.3351 7.15768,8.31028 6.98802,\n                  8.31028 C6.53344,8.31028 6.10606,8.48742 5.78476,8.8094 L5.69058,8.90358\n                  L5.74804,9.02394 C5.9789,9.50674 6.28932,9.94534 6.67114,10.3275 C7.0533,\n                  10.70898 7.49156,11.0194 7.97436,11.25026 C8.60438,11.5515 9.30818,11.71062\n                  10.01028,11.71062 C10.01062,11.71062 10.01028,11.71062 10.01062,11.71062\n                  C11.16934,11.71062 12.28386,11.28732 13.14712,10.51824 C13.21614,10.4567\n                  13.28346,10.39346 13.34976,10.32716 L15.6162,8.06038 C16.50836,7.16822 16.99932,\n                  5.98264 16.99932,4.72124 C16.99864,3.46086 16.50768,2.27494 15.61552,1.38278 Z"
              })
            )
          )
        )
      )
    )
  );
};

exports.default = ClipboardIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ClipboardIcon/ClipboardIcon.js
// module id = 557
// module chunks = 11